<template>
  <div class="akl" v-if="ready">
    <div class="bod-view-txt">
      <div class="os_noticeRes">
        <headers />
        <guide /> 
        <terms />
        <join @join="join" @alert="(type) => showLayer(type)"/>
        <guide_consumer />
        
      </div>
    </div>
  <popuplayer :layers="layerInfo" />
  </div>
</template>

<script>
import Vue from 'vue'
// Component
import headers from "./component/header.vue";
import guide from "./component/guide.vue";
import terms from "./component/terms.vue";
import join from "./component/join.vue";
import guide_consumer from "./component/guide_comsumer.vue";
import popuplayer from "./component/layerPopup.vue";


// Library
import axios from "axios";
import querystring from "querystring";

const SERVER_RESPONSE = {
    'ERR_DAY_BEING': 'begin',
    'ERR_ABO_NO': 'notJoin',
    'ERR_ABO_NAME': 'notJoin',
    'ERR_ABO_PHONE': 'validPhone',
    'ERR_DAY_END': 'closed',
    'ERR_ORDER_END': 'closed',
    'ERR_JOIN_IN': 'joinIn',
    'SUCCESS': 'joinCompleted'
}


export default {
  name: "a7070-glister",
  components: {
    headers,
    guide,
    terms,
    join,
    guide_consumer, 
    popuplayer,
  },
  data() {
    return {
      ready: true,
      layerInfo: {
        mode: {
          'begin' : 'ev_a7070xgli_pop1',
          'joinCompleted': 'ev_a7070xgli_pop2',
          'closed': 'ev_a7070xgli_pop3',
          'validTerms': 'ev_a7070xgli_pop4',
          'joinIn': 'ev_a7070xgli_pop5',
          'validPhone': 'ev_a7070xgli_pop6',
          'notJoin': 'ev_a7070xgli_pop7',
          'validName': 'ev_a7070xgli_pop8',
          'validPhoneEmpty': 'ev_a7070xgli_pop9',
          'validAboNumber': 'ev_a7070xgli_pop10',
        },
        selectItem : 'begin' 
      },
      
    };
  },
  methods: {
    init: async function () { // 초기화
      this.agree = false
      this.applyResult = -1
      this.au_token = ''
    },
    showLayer: function (type){
      this.layerInfo.selectItem = type
      // class 반영되는데 약간의 지연이 발생되어 0.5 초 지연을 후 Layer Popup 을 띄움
      window.setTimeout(() => {
          layerPopOver(this, '.'+ this.layerInfo.mode[type])
      }, 200)
    },
    join: async function(abonumber, aboname, phone) { 
      
      await axios.post(process.env.AWS_GATEWAY_URL_V2 + '/nutrilite/a7070-glister', {
          abo_no: abonumber,
          abo_nm: aboname,
          abo_phone: phone
        }
      ).then(response => {        
        const res = response.data
        this.showLayer(SERVER_RESPONSE[res['statusCode']])
      }).catch(ex => {
        console.log("ex :", ex)
        alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
      })
      
    },
  },
  mounted: function() {
    window.setTimeout(() => {
      this.ready = true
      this.init()
    }, 500)
  },
  created: async function() {
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/jquery-3.2.1.min.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/jquery-ui-1.12.1.min.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/jquery.colorbox-min.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/jquery.flexslider.js')

    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/owl.carousel.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/owl.carousel.custom.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/bootstrap.min.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/swiper.min.js')

    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/common/akl_common.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/common/akl_contents.js')
  }
};
</script>

<style scoped>
@import "./css/font_kr.css";
@import "https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-lib.css";
@import "https://www.amway.co.kr/_ui/responsive/theme-blue/css/base.css";
@import "https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common.css";
@import "https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common-new-v2.css";

body {
  margin: 0 auto;
}

.bod-view-txt {
  padding-top: 0;
}
#loading {
  display: none !important;
}


.os_noticeRes .osResHeader{background: url(https://www.amway.co.kr/_ui/_noticeImg/2023/03/0329_ev_a7070xgli/bg.jpg) no-repeat; padding-bottom: 62em; background-size: cover; background-position:center 90%;}
.os_noticeRes ul.list_syleOne li::before{content:''; height:16px; width:16px; border:1px solid #ddd; border-radius:50%; display:inline-block; vertical-align:middle; margin-right:.5em;}
.os_noticeRes .cont_info{align-items: center; display: flex;}
.os_noticeRes .cont_info label{margin-bottom:0;}
.os_noticeRes .cont_info input{border-radius:.5em;}
.os_noticeRes .cont_info input[type="text"]{padding:0 12px;}
.os_noticeRes .cont_info input::placeholder {font-size:14px; letter-spacing:-.8px;}

@media screen and (max-width:1250px) {
  .os_noticeRes .osResHeader{padding-bottom:56em;}
}
@media screen and (max-width:1024px) {
  .os_noticeRes .osResHeader{padding-bottom:49em;}
}
@media screen and (max-width:768px) {
  .os_noticeRes .osResHeader{padding-bottom:40em;}
}
  @media screen and (max-width:639px) {
  .os_noticeRes .osResHeader{padding-bottom:34em;}
}
</style>



// WEBPACK FOOTER //
// src/views/nutrilite/a7070-glister/index.vue